import { useState, useEffect } from 'react';
import { db } from '../lib/firebase';
import { doc, getDoc } from 'firebase/firestore';
import parse from 'html-react-parser';

export function LiveWidget() {
  const [config, setConfig] = useState<{ active: boolean; code: string } | null>(null);

  useEffect(() => {
    getDoc(doc(db, 'settings', 'general')).then(snap => {
      if (snap.exists() && snap.data().liveWidgetActive && snap.data().liveWidgetCode) {
        setConfig({
          active: snap.data().liveWidgetActive,
          code: snap.data().liveWidgetCode
        });
      }
    }).catch(() => {});
  }, []);

  if (!config?.active || !config?.code) return null;

  return (
    <div className="w-full bg-white dark:bg-gray-800 border-b border-gray-100 dark:border-gray-800 py-2 hide-on-print relative z-30">
      <div className="container mx-auto px-4 overflow-hidden flex justify-center dynamic-ad-container">
        {parse(config.code)}
      </div>
    </div>
  );
}
